module.exports = function (pageTitle) {
    return {
        event: 'pageUpdate',
        pageTitle,
    };
};



// WEBPACK FOOTER //
// ./src/common/pagemetadata/page-title-mapper.js